import { Card, CardBody, CardFooter, CardHeader, Col } from "reactstrap";
import { H3, H4, H6, P } from "../../../../AbstractElements";
import { BohoTheme } from "../../../../Constant";
import { CommonCardProp } from "../../../../Type/CommonComponant";

const CommonCard = ({ data }: CommonCardProp) => {
  return (
    <>
      <Col xl="4" sm={data.sm}>
        <Card className="height-equal">
          <CardHeader className={data.headerClass}>
            <H3 className={data.headingClass}>{data.title}</H3>
          </CardHeader>
          <CardBody className={data.bodyClass}>
            <H4 className="pb-2">{data.text}</H4>
            <P className="mb-0">{data.span}</P>
          </CardBody>
          <CardFooter className={data.footerClass}>
            <H6 className="mb-0 text-end">{BohoTheme}</H6>
          </CardFooter>
        </Card>
      </Col>
    </>
  );
};

export default CommonCard;
